module.exports = __webpack_public_path__ + "img/image17_2.d6a44ddf.png";